import { useAppState } from "../../context";
import { CategoryType } from "../../types";
import useCatalogFilterParams from "./useCatalogFilterParams";

const CatalogFilterTags = () => {
    const [categories] = useAppState<CategoryType[]>('categories', []);
    const { filters, clearFilter, updateFilter } = useCatalogFilterParams();

    // Format duration for display
    const formatDuration = (value: number) => {
        const minutes = Math.floor(value / 60);
        const seconds = Math.floor(value % 60).toString().padStart(2, '0');
        return `${minutes}:${seconds}`;
    };

    // Get category names from IDs
    const getCategoryNames = () => {
        if (!filters.categories?.length) return [];
        return categories
            .filter(cat => filters.categories?.includes(cat.id))
            .map(cat => ({ id: cat.id, name: cat.name }));
    };

    const handleCategoryRemove = (categoryId: number) => {
        const newCategories = filters.categories?.filter(id => id !== categoryId) || [];
        updateFilter('categories', newCategories);
    };

    const renderTags = () => {
        const tags = [];

        // Keyword tag
        if (filters.keyword) {
            tags.push({
                key: 'keyword',
                label: `Search: ${filters.keyword}`,
                onClick: () => clearFilter('keyword')
            });
        }

        // Amount tag
        if (filters.amount) {
            tags.push({
                key: 'amount',
                label: `Amount: ${filters.amount[0]}-${filters.amount[1]} pictures`,
                onClick: () => clearFilter('amount')
            });
        }

        // Duration tag
        if (filters.duration) {
            tags.push({
                key: 'duration',
                label: `Duration: ${formatDuration(filters.duration[0])}-${formatDuration(filters.duration[1])}`,
                onClick: () => clearFilter('duration')
            });
        }

        // Price tag
        if (filters.price) {
            tags.push({
                key: 'price',
                label: `Price: $${filters.price[0]}-$${filters.price[1]}`,
                onClick: () => clearFilter('price')
            });
        }

        // Category tags
        const categoryNames = getCategoryNames();
        if (categoryNames.length > 1 || (categoryNames.length > 0 && tags.length > 0)) {
            categoryNames.forEach(category => {
                tags.unshift({
                    key: `category-${category.name}`,
                    label: category.name,
                    onClick: () => handleCategoryRemove(category.id)
                });
            });
        }

        return tags;
    };

    const tags = renderTags();
    if (!tags.length) return null;

    return (
        <div className="catalog__tags tags">
            {tags.map(tag => (
                <button key={tag.key} className="tag" onClick={tag.onClick}>
                    <svg role="img" className="tag__ico">
                        <use href="./img/sprite.svg#cross"></use>
                    </svg>
                    {tag.label}
                </button>
            ))}
        </div>
    );
};

export default CatalogFilterTags;